import type { QueryFunctionContext } from '@tanstack/react-query';
import { WorkspacesService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import type { workspacesKeys } from 'app/queries/workspaces/workspacesKeys';

type TParams = QueryFunctionContext<ReturnType<typeof workspacesKeys.detailBySlugs>>;

export const createFetchWorkspaceQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ orgSlug, wsSlug }], signal }: TParams) =>
    call(() => cancelOnSignal(WorkspacesService.getWorkspaceBySlugs({ orgSlug, wsSlug }), signal));
